export enum ApiType {
  Default,
  DreambooksEditor,
  LfmExpress
}
